/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'
import Select from 'react-select'

export default class ItemField extends React.PureComponent {
  render() {
    const { onChange, data } = this.props

    return (
      <Form.Field>
        <label>Items</label>
        <Select
          menuPlacement="top"
          isMulti
          isClearable
          isSearchable
          isRtl={false}
          name="items"
          value={data.existedValue}
          isDisabled={false}
          className="basic-single"
          placeholder="Choose items"
          onChange={onChange}
          options={data.options}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/promotions/fields/itemsField.js